import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import Separator_module from "./Separator.module.js";
import { Text } from "../text/Text.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import { theme } from "../../theme/index.js";
const Separator = /*#__PURE__*/ forwardRef(({ direction = 'horizontal', testId, children, margin, className, theme: _theme, style, ...props }, ref)=>/*#__PURE__*/ jsxs("div", {
        "data-theme": _theme,
        "data-testid": testId,
        "data-direction": direction,
        className: combineClasses(Separator_module.separator, margin && Separator_module.margin, 'vertical' === direction && Separator_module.vertical, 'horizontal' === direction && Separator_module.horizontal, className),
        style: {
            '--separator--margin': margin ? theme.spacing[margin] : void 0,
            ...style
        },
        ...props,
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: Separator_module.separatorLine
            }),
            children && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Text, {
                        className: Separator_module.contents,
                        color: "gray-700",
                        children: children
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: Separator_module.separatorLine
                    })
                ]
            })
        ]
    }));
Separator.displayName = 'Separator';
export { Separator };
